const state = {
  symbols: []
};

const getters = {
  getSymbolPreset() {
    return [
      { symbol: "l", name: "symbols.litres" },
      { symbol: "m²", name: "symbols.square-meters" },
      { symbol: "m³", name: "symbols.cubic-meters" },
      { symbol: "kWh", name: "symbols.kilowatt-hours" },
      { symbol: "MWh", name: "symbols.megawatt-hours" },
      { symbol: "HCA", name: "symbols.HCA" }
    ];
  }
};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
